import { render, staticRenderFns } from "./MultipleModal.vue?vue&type=template&id=708922ff&scoped=true"
import script from "./MultipleModal.vue?vue&type=script&lang=ts"
export * from "./MultipleModal.vue?vue&type=script&lang=ts"
import style0 from "./MultipleModal.vue?vue&type=style&index=0&id=708922ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708922ff",
  null
  
)

export default component.exports